import { useLocation } from "react-router-dom";
import useAgentData from "../../utils/hooks/useAgentData";
import Search from "../shared/Search";

const formatAISuggestions = (suggestions) =>
  suggestions.map((item, index) => ({
    message: item.suggestion,
    bgColor: ["bg-[#FFFC0136]", "bg-[#CDFFB7]"][index] || "bg-gray-100",
    icon:
      ["/icons/idea.png", "/icons/ph_chat.png"][index] || "/icons/default.png",
    radius: ["rounded-[8px]", "rounded-[32px]"][index] || "rounded-md",
  }));

const AIsuggestions = () => {
  const { aiSuggestions, loading } = useAgentData();
  const location = useLocation();
  const isChatPath = ["/chat", "/email-inbox"].includes(location.pathname);

  if (loading || !aiSuggestions) return null;

  const aiSuggestionsData = formatAISuggestions(aiSuggestions);
  //min-h-screen
  return (
    <div
      className={`flex  w-full  bg-white pb-1   flex-col items-start justify-between  ${
        isChatPath ? " h-full " : ""
      }      `}
    >
      <div>
        <div
          className={`"w-full h-[22px]  flex items-start" ${
            isChatPath ? "border-b border-[#0000002B]  " : ""
          }`}
        >
          <h1 className="h-[24px] pl-2 text-[13px] font-semibold leading-[100%] text-black font-inter">
            AI suggestion{" "}
          </h1>
        </div>
        <div className="flex flex-col w-full gap-3 pl-0 mt-3 md:pl-3">
          {aiSuggestionsData.map((item, index) => (
            <div
              key={index}
              className={`w-full ${item.bgColor} ${item.radius} p-2 flex items-center gap-3`}
            >
              <img
                src={item.icon}
                alt="icon"
                className="w-[20px] h-[20px] object-contain"
              />
              <span className="lg:text-[10px] text-[10px] 2xl:text-[11px] font-inter text-[#00000073] text-opacity-80">
                {item.message}
              </span>
            </div>
          ))}
        </div>
      </div>

      <Search onChange={() => {}} onSend={() => {}} value="" disabled />
    </div>
  );
};

export default AIsuggestions;
